import { KEY_DOWN, KEY_UP } from "../redux/constants"

let previousTimeStamp = 0

/**
 * Sets up global listeners to the document and dispatches events if needed.
 * @param {*} store the redux store where the events will be dispatched
 */
export default function setupListeners(store) {
  addKeyDownListener(store)
  addKeyUpListener(store)
  addClickListener()
}

/**
 * Adds a _keydown_ listener to the document.
 * It will dispatch a KEY_DOWN event with the current key pressed.
 * This can happen at max once every 100ms.
 * @param {*} store the redux store where the event will be dispatched
 */
function addKeyDownListener(store) {
  document.addEventListener('keydown', e => {
    const newTime = new Date()
    if (newTime - previousTimeStamp > 100) {
      previousTimeStamp = newTime
      store.dispatch({
        type: KEY_DOWN,
        event: e
      })
    }
  })
}

/**
 * Adds a _keyup_ listener to the document.
 * It will dispatch a KEY_UP event with the current key pressed.
 * @param {*} store the redux store where the event will be dispatched
 */
function addKeyUpListener(store) {
  document.addEventListener('keyup', e => {
    store.dispatch({
      type: KEY_UP,
      event: e
    })
  })

}

/**
 * Adds a click listener to the document.
 * This will "unfocus" the clicked element by using "blur" on all elements
 * that has been clicked if its not a input-field.
 * This is to prevent the space-bar from acting as a "click" on focused elements.
 */
function addClickListener() {
  document.addEventListener('click', e => {
    const { target } = e

    const targetNode = target.nodeName.toLowerCase()
    if (targetNode === 'input' || targetNode === 'select')
      return

    target.blur()
  })
}